import React from "react";

const EditLabels = () => {
  return (
    <div id="labels">
      <div className="icon">
      <i className="fa-solid fa-hammer"></i>
      </div>
      <div className="content">
        <p>Under Construction!!  
        Contact Developer <a target="_blank" href="https://harshal-mukte.netlify.app/">Harshal Mukte</a></p>
      </div>
    </div>
  );
};

export default EditLabels;
